import { Block, Flex } from '@aloft/toolkit-sui';

import { useMemo } from 'react';

import { PropertyHeader } from '../../../components/PropertyHeader/PropertyHeader.tsx';
import { AivArvActiveTab } from '../../../redux/types.ts';
import { Header } from '../ColumnSections/Header.tsx';
import { EDIT_MODE_OFF } from '../consts.ts';

export const useHeaderByID = (
  handleObjectiveEditModeToggle: (id: string) => void,
  objectiveEditMode: string,
  aivArvTab?: AivArvActiveTab,
  inspectifyOrder?: boolean,
) =>
  useMemo(
    () =>
      ({ id }: { id: string }) => (
        <>
          <PropertyHeader propertyId={id} />
          <Flex>
            {aivArvTab && ['aiv', 'all'].includes(aivArvTab) && id === 'subject' && (
              <Block flex={1}>
                <Header
                  id={id}
                  onModeToggle={() => handleObjectiveEditModeToggle(id)}
                  editMode={objectiveEditMode === id ? 'objective' : 'subjective'}
                  disableEdit={objectiveEditMode !== EDIT_MODE_OFF}
                  indicatedValueTitle="As-Is Value"
                  hideEdit
                  backgroundColor="aiv"
                  textColor="aivText"
                />
              </Block>
            )}
            {aivArvTab && ['arv', 'all'].includes(aivArvTab) && id === 'subject' && (
              <Block flex={1}>
                <Header
                  id={'subjectArv'}
                  onModeToggle={() => handleObjectiveEditModeToggle(id)}
                  editMode={objectiveEditMode === id ? 'objective' : 'subjective'}
                  disableEdit={objectiveEditMode !== EDIT_MODE_OFF}
                  indicatedValueTitle="After-Repair Value"
                  hideEdit
                  backgroundColor="arv"
                  textColor="arvText"
                />
              </Block>
            )}
            {(!aivArvTab || id !== 'subject') && (
              <Block flex={1}>
                <Header
                  id={id}
                  onModeToggle={() => handleObjectiveEditModeToggle(id)}
                  editMode={objectiveEditMode === id ? 'objective' : 'subjective'}
                  disableEdit={objectiveEditMode !== EDIT_MODE_OFF}
                  hideEdit={inspectifyOrder}
                />
              </Block>
            )}
          </Flex>
        </>
      ),
    [handleObjectiveEditModeToggle, objectiveEditMode],
  );
